<template>
  <div>
    <el-row>
	  <el-col :span="22">
	    <el-row>
	      <el-col :span="8" class="f-z16 text-gradient3" style="font-weight: bold;">
	        {{ item.title }}
	      </el-col>
	      <el-col :span="16" style="font-size: 14px;line-height: 38px;
	      letter-spacing: 0.5px;">
	        处理截止时间：{{ item.overTime }}
	      </el-col>
	    </el-row>
		<label v-if="item.categoryName != '空铺'">
			<label v-if="role == 1">
			  <el-col :span="8" class="f-z15" v-if="active != 3" >
				预警门店数量：{{ item.mdCount }}
			  </el-col>
			</label>
			<label v-if="role == 2">
			  <el-col :span="8" v-if="item.categoryName != '收缴率' && item.categoryName != '租售比'" class="f-z15">
			    {{ item.categoryName }}：{{ item.dataIn }}
			  </el-col>
			  <label v-if="item.categoryName == '毛利率'">
				<el-col :span="8" class="f-z15">
			      	同期差
					<i v-if="item.fh" 
					:class="item.fh == 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"                                                                                 
					:style="item.fh == 1 ? 'color: green' : 'color: red'"></i>
					{{ item.tb }}%	
				</el-col>
				<el-col :span="8" class="f-z15">
				  标准值差异：<span v-if="item.fh1 && item.fh1 == 2">-</span>{{ item.ysjd }}	
				</el-col>	
			  </label>
              <label v-if="item.categoryName == '客流'">
				<el-col :span="8" class="f-z15">
			      	同比
					<i v-if="item.fh" 
					:class="item.fh == 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"                                                                                 
					:style="item.fh == 1 ? 'color: green' : 'color: red'"></i>
					{{ item.tb }}%	
				</el-col>
				<el-col :span="8" class="f-z15">
				  标准值差异：<span v-if="item.fh1 && item.fh1 == 2">-</span>{{ item.ysjd }}	
				</el-col>	
			  </label>
              <label v-if="item.categoryName == '营收'">
				<el-col :span="8" class="f-z15">
			      	同比
					<i v-if="item.fh" 
					:class="item.fh == 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"                                                                                 
					:style="item.fh == 1 ? 'color: green' : 'color: red'"></i>
					{{ item.tb }}%	
				</el-col>
				<el-col :span="8" class="f-z15">
				  预算完成率：<span v-if="item.fh1 && item.fh1 == 2">-</span>{{ item.ysjd }}	
				</el-col>	
			  </label>	
			  <label v-if="item.categoryName == '收缴率' || item.categoryName == '租售比'">	
			    <el-col :span="8" class="f-z15" v-if="active != 3" >
			      预警品牌数：{{ item.emptyShopCount }}
			    </el-col>
			  </label>						  
			</label>
			<label v-if="role > 2 || active == 3">
			  
			</label>
		</label>
		<label v-else>
		  <el-row>
			<el-col :span="8" class="f-z15" >
			  空铺：{{ item.emptyShopCount }}
			</el-col>
			<el-col :span="8" class="f-z15" >
			  超期空铺：{{ item.emptyShopOverdueCount }}
			</el-col>
		  </el-row>			
		</label>
	  </el-col>
	  <el-col :span="2" :style="role!= 3 && active != 3 ? 'line-height: 80px;font-size: 14px;color: red;cursor: pointer' : 'line-height: 40px;font-size: 14px;color: red;cursor: pointer'">
	    <span v-if="item.status == 0 || item.status == 2" @click="toTaskDetail(item)">去处理</span>
	    <span v-else-if="active == 3 " @click="handleView(item)">去审阅</span>
	    <span v-else @click="toTaskDetail(item, 1)">去查看</span>
	  </el-col>
	</el-row>
  </div>
	

</template>

<script>
export default {
  name: "taskItem",
  props: ['item', 'role', 'active'],
  data() {
	return {
	    
	}
  },
  created() {
  	
  },
  methods: {
	toTaskDetail(item, type = 0) {
	  this.$emit("addCallbackReturnTask", item, type)
	},
	handleView(item) {
      this.$emit("addCallbackReturnView", item)		
	}
  }
}
</script>

<style scoped>

</style>